import store from '@/store/index';
import { getAuthors, getAuthorApps } from '@/services/authorBackendTool';

export default {
  data() {
    return {
      // 各元件的無敵帳號所使用的獨立變數
      adminAppList: [], // 指定作者的APP清單
      adminSelect: {
        selectAuthor: {},
        selectApp: {},
      },

      adminAuthorForumId: {
        memberId: 0,
        userId: 0,
        groupId: 0,
      },
    };
  },
  computed: {
    allAuthorsList() {
      return store.getters.allAuthorsList;
    },

    authorAppList() {
      return store.getters.authorAppList;
    },
  },

  methods: {
    // 無敵帳號才會取得的，所有作者清單
    async getAllAuthors() {
      try {
        if (!this.allAuthorsList.length) {
          const data = await getAuthors();
          this.updateAllAuthorsList(data.authors);
        }

        // 上游故障時後端 fail-open 回空陣列，此時不要動 selectAuthor
        if (!this.allAuthorsList.length) return;

        const loginMemberId = store.getters.memberInfo.m;
        this.adminSelect.selectAuthor = this.allAuthorsList.find(
          (item) => item.memberId === loginMemberId,
        );

        // 無敵帳號沒有的話，作者取第一個
        if (this.adminSelect.selectAuthor === undefined) {
          [this.adminSelect.selectAuthor] = this.allAuthorsList;
        }
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * 取得指定作者的APP清單（store 內以 memberId 為 key 快取）
     * @param {Number} memberId 作者會員編號
     * @returns {Array} APP清單，該作者沒有APP時為空陣列
     */
    async getAuthorAppList(memberId) {
      if (!memberId) return [];
      if (this.authorAppList[memberId]) return this.authorAppList[memberId];

      try {
        const data = await getAuthorApps(memberId);
        const appList = data.appList || [];
        this.updateAuthorAppItem(memberId, appList);
        return appList;
      } catch (error) {
        console.log(error);
        return [];
      }
    },

    // 無敵帳號初始化：取得作者清單，並取所選作者的APP清單
    async initAdminAuthorApps() {
      await this.getAllAuthors();
      await this.setAdminAppList(this.adminSelect.selectAuthor?.memberId);
    },

    // 設定所選作者的APP清單與預設APP（該作者沒有APP時 selectApp 為 null）
    async setAdminAppList(memberId) {
      const appList = await this.getAuthorAppList(memberId);
      this.adminAppList = appList;
      this.adminSelect.selectApp = appList.length ? appList[0] : null;
      return appList;
    },

    // 取作者同學會memberId和groupId
    async getAdminAuthorForumIds() {
      try {
        const formData = new FormData();
        formData.append('action', 'getauthorforumids');
        formData.append('authorMemberId', this.adminSelect.selectAuthor.memberId);

        const data = await this.request(formData);
        if (data !== false) {
          if (data.data) {
            const ids = data.data[0];
            if (ids.length) {
              [
                this.adminAuthorForumId.memberId,
                this.adminAuthorForumId.userId,
                this.adminAuthorForumId.groupId,
              ] = ids;
            }
          } else {
            [
              this.adminAuthorForumId.memberId,
              this.adminAuthorForumId.userId,
              this.adminAuthorForumId.groupId,
            ] = [0, 0, 0];
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    updateAllAuthorsList(allAuthorsList) {
      store.dispatch('updateAllAuthorsList', {
        allAuthorsList,
      });
    },

    updateAuthorAppItem(memberId, appList) {
      store.dispatch('updateAuthorAppItem', {
        memberId,
        appList,
      });
    },
  },
};
